export function removeElements(array:Array<HTMLElement>) {
    array.forEach(el => {
        el.parentNode.removeChild(el);
    });
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/remove-elements.ts